<template>
   <div class="v-image" :style="{objectFit,width,height}">
      <img class="thumb" :src="thumb" :style="{objectFit,objectPosition,width,height,filter:'filter('+blur+')'}">
      <img class="full" :src="full" :style="{objectFit,objectPosition}">
   </div>
</template>
<style lang="less" scoped>
   .v-image {
      position: relative;

      .thumb {
         vertical-align: top;
         filter: blur(6px);
      }

      .full {
         width: 100%;
         height: 100%;
         position: absolute;
         left: 0;
         top: 0;
      }
   }
</style>
<script>
   export default {
      props: {
         src: {
            default: ""
         },
         width: {
            default: "auto"
         },
         height: {
            default: "auto"
         },
         objectFit: {
            default: "cover"
         },
         objectPosition: {
            default: "center"
         },
         blur: {
            default: "6px"
         }
      },
      computed: {
         thumb() {
            return this.src.split("?thumb=")[1] || this.src.split("?thumb=")[0];
         },
         full() {
            return this.src.split("?thumb=")[0];
         }
      }
   }
</script>